


























































































import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import { mapState } from "vuex";
import _ from "@/boot/lodash";

// Mixins
import RequestPromises from "@/mixins/requestPromises";

// Enums/Data
import { BrandConfigKeys } from "@/data/constants";

// Types
import { IBrand } from "@/models/brands";
import { IProduct } from "@/models/products";

@Component({
  computed: {
    ...mapState({
      suspendDays(state, getters) {
        return parseInt(
          _.get(
            getters[`brand/config`],
            BrandConfigKeys.SUBSCRIPTIONS_SUSPEND_INTERVAL
          )
        );
      },
      cancelDays(state, getters) {
        return parseInt(
          _.get(
            getters[`brand/config`],
            BrandConfigKeys.SUBSCRIPTIONS_CANCEL_INTERVAL
          )
        );
      },
      terminateDays(state, getters) {
        return parseInt(
          _.get(
            getters[`brand/config`],
            BrandConfigKeys.SUBSCRIPTIONS_CLOSE_INTERVAL
          )
        );
      }
    })
  }
})
export default class RecurringDueDateControl extends Mixins(RequestPromises) {
  // Props

  @Prop({ required: true })
  public brandId!: IBrand["id"];

  @Prop({ required: true })
  public value!: IProduct["payment_days_term"];

  @Prop({ default: -30 })
  public minValue!: number;

  @Prop({ default: 90 })
  public maxValue!: number;

  @Prop({ default: false })
  public isDisabled!: boolean;

  @Prop({ default: false })
  public allowBrandInheritance!: boolean;

  @Prop({ default: null })
  public brandValue!: IProduct["payment_days_term"];

  // Variables

  public readonly suspendDays;
  public readonly cancelDays;
  public readonly terminateDays;

  public inheritBrandDefault = this.$_.isNull(this.value);
  public localValue: number = this.inheritBrandDefault
    ? this.brandValue
    : this.value;

  // Methods

  public created() {
    this.$store.dispatch("brand/getConfig", {
      keys: [
        BrandConfigKeys.SUBSCRIPTIONS_SUSPEND_INTERVAL,
        BrandConfigKeys.SUBSCRIPTIONS_CANCEL_INTERVAL,
        BrandConfigKeys.SUBSCRIPTIONS_CLOSE_INTERVAL
      ],
      brandId: this.brandId
    });
  }

  // Computed

  public get label() {
    if (this.localValue < 0)
      return this.$tc(
        "_sentence.invoice.recurring_due_date_before_renewal_label",
        Math.abs(this.localValue)
      );
    return this.$tc(
      "_sentence.invoice.recurring_due_date_after_renewal_label",
      this.localValue
    );
  }

  public get summary() {
    return this.$t("_sentence.invoice.recurring_due_date_summary", {
      startDate: this.$moment().format("MMMM Do"),
      endDate: this.$moment()
        .add(this.localValue, "d")
        .format("MMMM Do")
    });
  }

  public get suspendConflictWarning() {
    if (isNaN(this.suspendDays)) return null;
    if (this.suspendDays >= this.localValue) return null;
    return {
      path: "_sentence.invoice.recurring_due_date_suspend_conflict_warning",
      days: this.suspendDays,
      daysDiff: this.localValue - this.suspendDays
    };
  }

  public get cancelConflictWarning() {
    if (isNaN(this.cancelDays)) return null;
    if (this.cancelDays >= this.localValue) return null;
    return {
      path: "_sentence.invoice.recurring_due_date_cancel_conflict_warning",
      days: this.cancelDays,
      daysDiff: this.localValue - this.cancelDays
    };
  }

  public get terminateConflictWarning() {
    if (isNaN(this.terminateDays)) return null;
    if (this.terminateDays >= this.localValue) return null;
    return {
      path: "_sentence.invoice.recurring_due_date_terminate_conflict_warning",
      days: this.terminateDays,
      daysDiff: this.localValue - this.terminateDays
    };
  }

  public get conflictWarning() {
    return (
      this.suspendConflictWarning ||
      this.cancelConflictWarning ||
      this.terminateConflictWarning
    );
  }

  // Watchers

  @Watch("inheritBrandDefault")
  public onInheritBrandDefaultChange() {
    this.localValue = this.brandValue;
    this.onLocalValueChange();
  }

  @Watch("localValue")
  public onLocalValueChange() {
    this.$emit("input", this.inheritBrandDefault ? null : this.localValue);
  }

  @Watch("value", { immediate: true })
  public onPassedValueChange() {
    this.inheritBrandDefault = this.$_.isNull(this.value);
    this.localValue = this.inheritBrandDefault ? this.brandValue : this.value;
  }
}
